import {
    EntityPanelFormGroup,
    EntityPanelGroupHeader,
} from '../../../panels/entity-panels/entity-panel-components';
import { FormSelect } from '../../../forms/integrated-form-controls/form-select';
import React, { useMemo } from 'react';
import { BoloPanelFormType } from '@mark43/cad-api';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { Checkbox, FormRow, Box } from '@cad-arc';
import { useDispatchAreaStore } from '../../../dispatch-areas/use-dispatch-areas';
import { usePrimaryPoliceSubdivisionOptions } from './use-primary-police-subdivision-options';

const maxOptionsToShow = 3;
export const BoloFormRecipientFields = ({ form }: { form: UseFormReturn<BoloPanelFormType> }) => {
    const { control } = form;

    const dispatchAreas = useDispatchAreaStore();

    const dispatchAreaOptions = useMemo(() => {
        return dispatchAreas.allDispatchAreaObjects.map((dispatchArea) => ({
            label: dispatchArea.name,
            value: dispatchArea.id,
        }));
    }, [dispatchAreas]);

    const selectedDispatchAreas = useWatch({
        name: 'dispatchAreaRecipients',
        control,
    });

    const allDispatchAreasSelected = selectedDispatchAreas.length === dispatchAreaOptions.length;

    const onSelectAllDispatchAreas = () => {
        form.setValue(
            'dispatchAreaRecipients',
            allDispatchAreasSelected ? [] : dispatchAreaOptions
        );
    };

    const subdivisionOptions = usePrimaryPoliceSubdivisionOptions();

    const selectedSubdivisions = useWatch({
        name: 'subdivisionRecipients',
        control,
    });

    const allSubdivisionsSelected = selectedSubdivisions.length === subdivisionOptions.length;

    const onSelectAllSubdivisions = () => {
        form.setValue('subdivisionRecipients', allSubdivisionsSelected ? [] : subdivisionOptions);
    };

    return (
        <EntityPanelFormGroup data-testid="bolo-form-recipient-fields" spacing={3}>
            <EntityPanelGroupHeader title="BOLO Recipients" />
            <FormRow>
                <FormSelect
                    size="sm"
                    length="md"
                    options={dispatchAreaOptions}
                    name="dispatchAreaRecipients"
                    control={control}
                    label="D-Area"
                    isMultiple
                    truncateSelectedCount={maxOptionsToShow}
                />
                <Box w="90px" alignSelf="center">
                    <Checkbox
                        isChecked={allDispatchAreasSelected}
                        onChange={onSelectAllDispatchAreas}
                    >
                        Select All
                    </Checkbox>
                </Box>
            </FormRow>
            <FormRow>
                <FormSelect
                    size="sm"
                    length="md"
                    options={subdivisionOptions}
                    name="subdivisionRecipients"
                    control={control}
                    label="Subdivision"
                    isMultiple
                    truncateSelectedCount={maxOptionsToShow}
                />
                <Box w="90px" alignSelf="center">
                    <Checkbox
                        isChecked={allSubdivisionsSelected}
                        onChange={onSelectAllSubdivisions}
                    >
                        Select All
                    </Checkbox>
                </Box>
            </FormRow>
        </EntityPanelFormGroup>
    );
};
